import * as FIELD_NAME from 'constant/form-item-names'
import * as RULES from 'constant/form-rules'
import { connect } from 'react-redux'
import { Select, Form } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'

const { Option } = Select

const handleUpdate = (prevValues, currentValues) => prevValues.category_uuid !== currentValues.category_uuid

const SubCategorySelect = ({ categories, handleChange, hidden = false }) => (
  <Form.Item
    noStyle
    shouldUpdate={handleUpdate}
  >
    {({ getFieldValue }) => {
      const category = categories.filter(({ uuid }) => (getFieldValue(FIELD_NAME.CATEGORY_UUID) || []).includes(uuid))
      return category?.length
        ? (
          <Form.Item
            name={FIELD_NAME.SUB_CATEGORY_UUID}
            rules={[RULES.REQUIRED]}
          >
            <Select
              bordered={false}
              mode='multiple'
              onChange={handleChange}
              placeholder={'Sub-Category'}
              size='large'
              style={{ background: '#fff' }}
            >
              {category.map((category) => category.sub_categories.map(({ name, site_name: siteName, uuid }) => (
                <Option
                  key={`${category.uuid}${uuid}`}
                  value={uuid}
                >
                  {siteName}:&nbsp;{name}
                </Option>
              )))}
            </Select>
          </Form.Item>
        )
        : null
    }}
  </Form.Item>)

SubCategorySelect.propTypes = {
  categories: PropTypes.array,
  handleChange: PropTypes.func,
  hidden: PropTypes.bool
}

const mapStateToProps = (state) => ({
  categories: state.category.categories
})

export default connect(mapStateToProps)(SubCategorySelect)
